// src/app/components/training/TrainingDataPage.tsx
import React from "react";
import { Box, Center, Flex, Loader, Text } from "@mantine/core";
import { useGetTdroomAllQuery } from "../../openapi";
import { TrainingDataTable } from "./TrainingDataTable";
import { TrainingRoomViewer } from "./TrainingDataViewer";
import { useAppSelector } from "../app/hooks";
import { IRootState } from "../app/store";

export const TrainingDataPage: React.FC = () => {
  const activeTdRoomId = useAppSelector((s: IRootState) => s.training.activeTdRoomId);
  const { data, isLoading, isError, error } = useGetTdroomAllQuery();

  if (isLoading) {
    return (
      <Center h="100%">
        <Loader />
      </Center>
    );
  }

  if (isError) {
    return (
      <Center h="100%">
        <Box>
          <Text fw={600}>Klarte ikke å hente treningsdata</Text>
          <Text size="sm" c="dimmed">
            {typeof error === "object" ? JSON.stringify(error) : String(error)}
          </Text>
        </Box>
      </Center>
    );
  }

  // data er hentet her (brukes senere av tabell/viewer)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const rooms = data ?? [];

  return (
    <Flex w="100%" h="100%" gap="md">
      <Box w={520} style={{ borderRight: "1px solid var(--mantine-color-gray-3)" }}>
        <TrainingDataTable />
      </Box>

      {activeTdRoomId != null && (
        <Box w="100%" h="100%" style={{ flex: 1, minWidth: 0 }}>
          <TrainingRoomViewer />
        </Box>
      )}
    </Flex>
  );
};
